import { Card } from "@progress/kendo-react-layout";

interface AdminTabContentProps {
    children: React.ReactNode;
    scrollable?: boolean;
}

const AdminTabContent: React.FC<AdminTabContentProps> = ({ children, scrollable = false }) => (
    <Card
        className={scrollable ? "admin-tab-content overflow-y-auto" : "admin-tab-content overflow-hidden"}
        style={{ height: "100%", minHeight: 0 }}
    >
        {children}
    </Card>
);

export default AdminTabContent;
